export const TV_CHART_BRIDGE_ACTION = {
  WEBVIEW_LOADED: "WEBVIEW_LOADED",
  INIT: "init",
  DF_ON_READY: "DF_ON_READY",
  DF_RESOLVE_SYMBOL: "DF_RESOLVE_SYMBOL",
  DF_GET_BARS: "DF_GET_BARS",
  DF_SUBSCRIBE_BARS: "DF_SUBSCRIBE_BARS",
  DF_UNSUBSCRIBE_BARS: "DF_UNSUBSCRIBE_BARS",
  DF_RESPONSE: "DF_RESPONSE",
  DF_REALTIME_BAR: "DF_REALTIME_BAR",
  SAVE_CHART: "SAVE_CHART",
  CHART_READY: "CHART_READY",
  TEMPLATES_LIST: "TEMPLATES_LIST",
  TEMPLATE_ADD: "TEMPLATE_ADD",
  TEMPLATE_OVERWRITE: "TEMPLATE_OVERWRITE",
  TEMPLATE_RENAME_OR_UPDATE: "TEMPLATE_RENAME_OR_UPDATE",
  TEMPLATE_REMOVE: "TEMPLATE_REMOVE",
  TEMPLATE_APPLY_DETAILS: "TEMPLATE_APPLY_DETAILS",
  ANALYSES_LIST: "ANALYSES_LIST",
  ANALYSIS_ADD: "ANALYSIS_ADD",
  ANALYSIS_UPDATE_META: "ANALYSIS_UPDATE_META",
  ANALYSIS_SET_VISIBILITY: "ANALYSIS_SET_VISIBILITY",
  ANALYSIS_REMOVE: "ANALYSIS_REMOVE",
  ANALYSIS_APPLY_DETAILS: "ANALYSIS_APPLY_DETAILS",
  BACKUPS_LIST: "BACKUPS_LIST",
  BACKUP_RESTORE_DETAILS: "BACKUP_RESTORE_DETAILS",
  BACKUPS_UPDATED: "BACKUPS_UPDATED",
  SHAPES_UPDATE: "SHAPES_UPDATE",
  MARKERS_UPDATE: "MARKERS_UPDATE",
  DRAWN_OBJECTS_OPTIONS_UPDATE: "DRAWN_OBJECTS_OPTIONS_UPDATE",
  PRICE_ALERTS_UPDATE: "PRICE_ALERTS_UPDATE",
  MARK_CLICK: "MARK_CLICK",
  OPEN_PRICE_ALERT: "OPEN_PRICE_ALERT",
  OPEN_STOCKS_LIST: "OPEN_STOCKS_LIST",
  OPEN_FULLSCREEN_CHART: "OPEN_FULLSCREEN_CHART"
};
